import React from 'react';
import { Typography } from '../../../UIKit';
import { IEvent } from '../../../Models/DTO/Event.model';
import { FONT_SIZE_LARGE } from '../../../Constants/UI.constants';
import { PRIMARY_BLUE } from '../../../Constants/Colors.constants';
import { useDateFns, useUUID, getTranslationKeyForDay } from '../../../Hooks';
import { useTranslation } from 'react-i18next';
import { EventList } from './EventList.component';
import { makeStyles } from '~/UIKit/Style';
import { add, format } from 'date-fns';

interface EventListViewProps {
  events: IEvent[][];
  currentDate: Date;
}

const useStyles = makeStyles({
  eventListSectionTitle: {
    fontSize: FONT_SIZE_LARGE,
    lineHeight: '28px',
    margin: '35px 15px 15px 15px',
  },
  eventListSectionTitleToday: {
    color: PRIMARY_BLUE,
  },
});

export const EventListView = ({ events, currentDate }: EventListViewProps) => {
  const { classes } = useStyles();
  const { isDateToday } = useDateFns();
  const { t } = useTranslation();
  const date = (index: number) => add(currentDate, { days: index });
  const { createUUID } = useUUID();

  const dayToShow = (index: number) => {
    const isTodayOrTomorrow = index === 0 ? t('app.today') : t('app.tomorrow');

    return (
      <span>
        {index <= 1 && isDateToday(currentDate.toLocaleDateString())
          ? isTodayOrTomorrow
          : t(getTranslationKeyForDay(date(index)))}
        <b> | {format(date(index), 'dd LLL yyyy')}</b>
      </span>
    );
  };

  return (
    <>
      {events?.map((event, index) =>
        event.length ? (
          <React.Fragment key={createUUID()}>
            <Typography data-testid="event-list-title" className={classes.eventListSectionTitle}>
              {dayToShow(index)}
            </Typography>
            <EventList events={event} />
          </React.Fragment>
        ) : null,
      )}
    </>
  );
};
